import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import HeaderPage from "../components/HeaderPage";
import { useAsignaturas } from "../context/AsignaturasContext";
import AsignaturasForm from "../components/Asignaturas/AsignaturasForm";
import AsignaturasTable from "../components/Asignaturas/AsignaturasTable";
import AsignacionesSalones from "../components/Asignaturas/AsignacionesSalones";
import Notification from "../components/Notification";

const AsignaturasPage = () => {
  const {
    asignaturas,
    asignaturasConSalones,
    loading,
    fetchAsignaturas,
    fetchAsignaturasConSalones,
    crearAsignatura,
    editarAsignatura,
    eliminarAsignaturaData,
  } = useAsignaturas();

  const [notification, setNotification] = useState(null);
  const [editingAsignatura, setEditingAsignatura] = useState(null);
  const [vistaActual, setVistaActual] = useState("lista"); // 'lista' o 'asignaciones'

  useEffect(() => {
    fetchAsignaturas();
    fetchAsignaturasConSalones();
  }, []);

  const handleEdit = (asignatura) => {
    setEditingAsignatura(asignatura);
    setVistaActual("lista");
  };

  const handleDelete = async (id) => {
    try {
      await eliminarAsignaturaData(id);
      setNotification({ type: "success", message: "Asignatura eliminada correctamente" });
    } catch (error) {
      setNotification({ type: "error", message: "Error al eliminar asignatura" });
    }
  };

  const handleSave = async (data) => {
    try {
      if (editingAsignatura) {
        await editarAsignatura(editingAsignatura.asignatura_id, data);
        setNotification({ type: "success", message: "Asignatura actualizada correctamente" });
      } else {
        await crearAsignatura(data);
        setNotification({ type: "success", message: "Asignatura creada correctamente" });
      }
      setEditingAsignatura(null);
    } catch (error) {
      setNotification({ type: "error", message: "Error al guardar asignatura" });
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-6 overflow-y-auto">
        <HeaderPage title="Gestión de Asignaturas" />

        {/* Tabs de navegación */}
        <div className="flex gap-4 mb-6">
          <button
            onClick={() => setVistaActual("lista")}
            className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
              vistaActual === "lista"
                ? "bg-blue-600 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            📚 Asignaturas
          </button>
          <button
            onClick={() => setVistaActual("asignaciones")}
            className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
              vistaActual === "asignaciones"
                ? "bg-blue-600 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            🏫 Asignaciones a Salones
          </button>
        </div>

        {loading ? (
          <p className="text-center text-xl font-semibold">Cargando...</p>
        ) : vistaActual === "lista" ? (
          <>
            <AsignaturasForm
              onSave={handleSave}
              editingAsignatura={editingAsignatura}
              onClear={() => setEditingAsignatura(null)}
            />
            <AsignaturasTable
              asignaturas={asignaturasConSalones}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          </>
        ) : (
          <AsignacionesSalones
            asignaturasConSalones={asignaturasConSalones}
            showNotification={setNotification}
          />
        )}
      </div>

      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
};

export default AsignaturasPage;